export default {
  description: '{{name}} en {{city}}. Menú oficial. Ahorra dinero y pide aquí en línea.',
};
